import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/internal/Subject';
import {UploadedFile} from '@interfaces/file.interface';

export interface PreviewModalOptions {
    files?: UploadedFile[];
    title?: string;
    contentBefore?: string;
}

@Injectable()
export class PreviewModalService {
    private _show$ = new Subject<PreviewModalOptions>();

    public show$ = this._show$.asObservable();

    public show(options: PreviewModalOptions) {
        if (!options.title) {
            options.title = `Просмотр ${options.files ? (options.files.length > 1 ? 'файлов' : 'файла') : ''}`;
        }

        this._show$.next(options);
    }
}
